import { useInView } from "@/hooks/use-in-view"

const STATS = [
	{ value: "60+", label: "Exchanges" },
	{ value: "All", label: "Major Currencies" },
	{ value: "50yr", label: "Projections" },
]

export function TrustMetrics() {
	const { ref, inView } = useInView()

	return (
		<div ref={ref} className={`transition-opacity duration-700 ease-out ${inView ? "opacity-100" : "opacity-0"}`}>
			<div className="py-8 px-4 border-y border-sky-100/60 dark:border-sky-800/20 bg-white/30 dark:bg-sky-950/20">
				<div className="max-w-3xl mx-auto grid grid-cols-3 gap-4">
					{STATS.map(({ value, label }) => (
						<div key={label} className="text-center py-4 px-2">
							<div className="text-3xl sm:text-4xl font-extrabold text-sky-600 dark:text-sky-400">
								{value}
							</div>
							<div className="text-sm font-medium text-sky-700/70 dark:text-sky-400/60 mt-1">{label}</div>
						</div>
					))}
				</div>
			</div>
		</div>
	)
}
